// GA4용 이벤트 헬퍼 (권장)
export const logEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag("event", eventName, params);
    console.log("Logged event:", eventName, params);
  }
};

// 페이지 뷰 추적 함수
export const logPageView = (path) => {
  if (window.gtag) {
    window.gtag("config", "G-L9ZVEXNG8S", {
      page_path: path,
    });
    console.log(`Logged page view for: ${path}`);
  }
};
